/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Business_Hero_CtaInputs */

const en_business_hero_cta = /** @type {(inputs: Business_Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Sales`)
};

const es_business_hero_cta = /** @type {(inputs: Business_Hero_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactar ventas`)
};

/**
* | output |
* | --- |
* | "Contact Sales" |
*
* @param {Business_Hero_CtaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const business_hero_cta = /** @type {((inputs?: Business_Hero_CtaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Business_Hero_CtaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_business_hero_cta(inputs)
	return en_business_hero_cta(inputs)
});